// Fuente única de metadata del estudio Ipsos 2025 (10.1) — todo dato que hoy vive hardcodeado
// en los componentes de /categorias/* pasa por acá. Ningún número suelto: cada valor se
// declara con ipsos(...) (viene del estudio, con lámina/pregunta/base) o supuesto(...)
// (decisión comercial, con nota y quién la definió). El badge de UI (BadgeDato) lee `tipo`
// para colorear y arma el tooltip con el resto de los campos.
export const ESTUDIO = {
  nombre: "Ipsos 2025",
  anio: 2025,
  pais: "Chile",
  casos: 400,
  edificios: 7,
};

export const ipsos = (valor, { lamina, pregunta, base, nota } = {}) => ({
  tipo: "ipsos",
  valor,
  lamina,
  pregunta,
  base,
  nota,
});

export const supuesto = (valor, { nota, definidoPor = "Ignacio", fecha = "2026-09-28" } = {}) => ({
  tipo: "supuesto",
  valor,
  nota,
  definidoPor,
  fecha,
});
